(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[545],{

/***/ 3278:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/escuela/[slug]/[locale]",
      function () {
        return __webpack_require__(3955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ getFollowSchools; },
/* harmony export */   "Dl": function() { return /* binding */ getPlacementTest; },
/* harmony export */   "Lx": function() { return /* binding */ getRoutesProgress; },
/* harmony export */   "iC": function() { return /* binding */ followSchool; },
/* harmony export */   "it": function() { return /* binding */ saveEmail; },
/* harmony export */   "mt": function() { return /* binding */ unFollowSchool; },
/* harmony export */   "uA": function() { return /* binding */ getRouteProgress; }
/* harmony export */ });
/* unused harmony exports getHeader, getIdentity, getExplore, getContactInfo, getPriceTable, getSchool, getCommunityInfo, getRoute, getUserPlans, getB2bPlans */
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3099);
/* harmony import */ var src_env__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3223);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6394);



var getHeader = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.header);
};
var getIdentity = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.identity);
};
var getExplore = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.explore);
};
var getContactInfo = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.contactInfo);
};
var getPriceTable = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.client.tablePrice);
};
var getSchool = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.school(slug));
};
var getCommunityInfo = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.community(slug));
};
var getRoute = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.route(slug));
};
var getFollowSchools = function() {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.getFollowSchools */ .b.client.schools.getFollowSchools);
};
var followSchool = function(schoolId, payload) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).post(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.followSchool */ .b.client.schools.followSchool(schoolId), payload);
};
var unFollowSchool = function(schoolId) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).delete(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.unFollowSchool */ .b.client.schools.unFollowSchool(schoolId));
};
var getPlacementTest = function(schoolSlug) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.placement_test */ .b.client.schools.placement_test(schoolSlug));
};
var getRoutesProgress = function(schoolSlug) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.routesProgress */ .b.client.schools.routesProgress(schoolSlug));
};
var saveEmail = function(payload) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance().post(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.registerEmail */ .b.client.registerEmail, payload);
};
var getUserPlans = function() {
    return http.axiosInstance().get(schoolsApi.client.userPlans);
};
var getB2bPlans = function() {
    return http.axiosInstance().get(schoolsApi.client.b2bPlans);
};
var getRouteProgress = function(id) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance().get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.routes.routeProgress */ .b.client.routes.routeProgress(id));
};


/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ PricingTable; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(6110);
// EXTERNAL MODULE: ./node_modules/@platzi/micro-ui.plans/dist/es/index.js + 74 modules
var dist_es = __webpack_require__(9122);
// EXTERNAL MODULE: ./src/components/shared/PricingTable/PricingTable.module.sass
var PricingTable_module = __webpack_require__(5795);
var PricingTable_module_default = /*#__PURE__*/__webpack_require__.n(PricingTable_module);
;// CONCATENATED MODULE: ./src/components/shared/PricingTable/PricingTable.tsx





var PricingTable = function() {
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("isLogged");
    });
    var user = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("userInfo");
    }, es/* shallowEqual */.wU).toJS();
    var paywalls = (0,es/* useSelector */.v9)(function(state) {
        return state.get("plans");
    }, es/* shallowEqual */.wU).toJS();
    var banner = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("promo_banner");
    }, es/* shallowEqual */.wU).toJS() || null;
    var isFreeOrUnsubscribed = [
        "unsubscribed",
        "free"
    ].includes(user === null || user === void 0 ? void 0 : user.userType);
    var onClickPlan = function(plan) {
        window.location.href = (plan === null || plan === void 0 ? void 0 : plan.buy_url) || "/comprar/".concat(plan === null || plan === void 0 ? void 0 : plan.slug);
    };
    var messages = {
        title: "Suscr\xedbete y potencia tu futuro profesional",
        subtitle: "Contenido profesional y actualizado con certificados digitales.",
        disclaimer: "Nunca subiremos el precio si mantienes tu suscripci\xf3n activa",
        b2bTitle: "Calcula el precio para tu empresa"
    };
    var showDisclaimer = (paywalls === null || paywalls === void 0 ? void 0 : paywalls.country_code) !== "AR";
    if (!Object.keys(paywalls).length) return null;
    if (isLogged && !isFreeOrUnsubscribed) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (PricingTable_module_default()).PricingTable,
        id: "planes",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "u-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* PlansTable */.vZ, {
                plans: paywalls,
                messages: messages,
                showDisclaimer: showDisclaimer,
                onClickPlan: onClickPlan,
                showBanner: true,
                withB2BTab: true,
                promoBanner: banner
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/shared/PricingTable/index.ts



/***/ }),

/***/ 5065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ShareButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(2814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__(2825);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/index-097a0a02.js + 1 modules
var index_097a0a02 = __webpack_require__(8888);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Button-843a7058.js
var Button_843a7058 = __webpack_require__(3893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(1417);
;// CONCATENATED MODULE: ./src/components/shared/Share/socialNetwork.ts

var socialNetwork = function(url, title) {
    var routeOrSchool = (url === null || url === void 0 ? void 0 : url.includes("ruta")) ? "Ruta" : "Escuela";
    var whatsappCopy = (url === null || url === void 0 ? void 0 : url.includes("ruta")) ? "https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Ruta%20de%20Aprendizaje%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ".concat(url) : "https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Escuela%20de%20".concat(title, "%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ").concat(url);
    return [
        {
            network: "whatsapp",
            url: whatsappCopy,
            icon: free_brands_svg_icons_index_es/* faWhatsapp */.VHX,
            class: "whatsapp"
        },
        {
            network: "twitter",
            url: "https://twitter.com/intent/tweet/?text=Inici%C3%A9%20la%20".concat(routeOrSchool, "%20de%20").concat(title, "%20en%20@platzi%20%F0%9F%92%9A%20Suscr%C3%ADbete%20y%20s%C3%A9%20parte%20de%20la%20comunidad%20de%20aprendizaje%20m%C3%A1s%20grande%20de%20Latinoam%C3%A9rica.%20").concat(url),
            icon: free_brands_svg_icons_index_es/* faTwitter */.mdU,
            class: "twitter"
        },
        {
            network: "telegram",
            url: "https://telegram.me/share/url?text=%C2%A1Mira!%20Encontr%C3%A9%20la%20".concat(routeOrSchool, "%20de%20").concat(title, "%20en%20Platzi%20%C2%BFy%20si%20la%20empezamos%20y%20aprendemos%20en%20comunidad?%20").concat(url),
            icon: free_brands_svg_icons_index_es/* faTelegramPlane */.IKq,
            class: "telegram"
        },
        {
            network: "facebook",
            url: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: free_brands_svg_icons_index_es/* faFacebookF */.AYu,
            class: "facebook"
        },
        {
            network: "linkedin",
            url: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(url),
            icon: free_brands_svg_icons_index_es/* faLinkedinIn */.hwn,
            class: "linkedin"
        }, 
    ];
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/ModalPortal-3d0cff28.js
var ModalPortal_3d0cff28 = __webpack_require__(4175);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-4abe4715.js
var index_4abe4715 = __webpack_require__(4230);
// EXTERNAL MODULE: ./src/components/shared/Share/ShareModal.module.sass
var ShareModal_module = __webpack_require__(7601);
var ShareModal_module_default = /*#__PURE__*/__webpack_require__.n(ShareModal_module);
;// CONCATENATED MODULE: ./src/components/shared/Share/ShareModal.tsx








var eventsSentSocialMedia = [];
var ShareModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(props.pathToShare), inputValue = ref[0], setInputValue = ref[1];
    var TIME_TO_FEEDBACK_USER = 1000;
    if (!props.showModal || !props.socialNetwork) return null;
    var handleCopyUrl = function() {
        var currentURl = props.pathToShare;
        navigator.clipboard.writeText(currentURl);
        setInputValue(t("escuela.share.copied"));
        setTimeout(function() {
            setInputValue(currentURl);
        }, TIME_TO_FEEDBACK_USER);
    };
    var handleSocialMediaClick = function(item) {
        return function() {
            if (props.recordSocialMediaClick && !eventsSentSocialMedia.includes(item.network)) {
                index_097a0a02.q.send({
                    event: props.recordSocialMediaClick.event,
                    route_slug: props.recordSocialMediaClick.route_name,
                    network_name: item.network
                });
                eventsSentSocialMedia.push(item.network);
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal_3d0cff28.M, {
        show: props.showModal,
        close: function() {
            return props.handleShowModal(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_4abe4715.C, {
            isDark: true,
            customClass: (ShareModal_module_default()).Card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (ShareModal_module_default()).CloseModal,
                    type: "button",
                    onClick: function() {
                        return props.handleShowModal(false);
                    },
                    "aria-label": t("escuela.share.buttonCloseModal"),
                    "data-testid": "modal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faTimes */.NBC,
                        size: "sm"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: props.sharedCopy
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: props.socialNetwork.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (ShareModal_module_default())[item.class],
                                        onClick: handleSocialMediaClick(item),
                                        href: item.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": t("escuela.share.socialNetwork", {
                                            network: item.network
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: item.icon,
                                            size: "lg"
                                        })
                                    })
                                }, "network-".concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ShareModal_module_default()).Input,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: inputValue ? inputValue : props.pathToShare,
                                    readOnly: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: handleCopyUrl,
                                    "aria-label": t("escuela.share.copyUrl"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_regular_svg_icons_index_es/* faCopy */.kZ_
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/shared/Share/ShareButton.module.sass
var ShareButton_module = __webpack_require__(5853);
var ShareButton_module_default = /*#__PURE__*/__webpack_require__.n(ShareButton_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/shared/Share/ShareButton.tsx











var clickEventSent = false;
var ShareButton = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), showShareModal = ref3[0], setShowShareModal = ref3[1];
    var ref4 = (0,react.useState)(""), pathToShare = ref4[0], setPathToShare = ref4[1];
    (0,react.useEffect)(function() {
        setPathToShare(window.location.href);
    }, []);
    var handleClick = function() {
        if (props.recordClickEvent && !clickEventSent) {
            index_097a0a02.q.send((0,_object_spread/* default */.Z)({}, props.recordClickEvent));
            clickEventSent = true;
        }
        setShowShareModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_843a7058.B, {
                as: "button",
                color: "sky",
                hierarchy: "tertiary",
                customClass: classnames_default()((ShareButton_module_default()).Button, props.customClass),
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faShareNodes */.M6U
                    }),
                    props.isLogged ? (ref = props.messages) === null || ref === void 0 ? void 0 : ref.isLogged : (ref1 = props.messages) === null || ref1 === void 0 ? void 0 : ref1.notLogged
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                socialNetwork: socialNetwork(pathToShare, props.socialNetworkTitle),
                showModal: showShareModal,
                handleShowModal: setShowShareModal,
                pathToShare: pathToShare,
                sharedCopy: (ref2 = props.messages) === null || ref2 === void 0 ? void 0 : ref2.sharedCopy,
                recordSocialMediaClick: props.recordSocialMediaClick
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shared/Share/index.ts



/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _platzi_micro_ui_signup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4150);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var useSignUpModal = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showSignup = ref[0], setShowSignup = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), signupUrl = ref1[0], setSignupUrl = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setSignupUrl(window.location.href);
    }, []);
    var openSignup = function() {
        setShowSignup(true);
    };
    var closeSignup = function() {
        setShowSignup(false);
    };
    var SignUpComponent = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platzi_micro_ui_signup__WEBPACK_IMPORTED_MODULE_1__/* .Signup */ .Al, {
            showSignup: showSignup,
            closeSignup: closeSignup,
            isModal: true,
            customNextUrl: signupUrl
        });
    };
    return {
        showSignup: showSignup,
        setShowSignup: setShowSignup,
        signupUrl: signupUrl,
        setSignupUrl: setSignupUrl,
        openSignup: openSignup,
        closeSignup: closeSignup,
        SignUpComponent: SignUpComponent
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSignUpModal);


/***/ }),

/***/ 3955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _locale_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(6110);
;// CONCATENATED MODULE: ./src/components/escuela/Layout/Layout.tsx








var sendEvent = false;
var sendAnalyticsEvent = false;
var Layout_Layout = function() {
    var ref;
    var isLogged = useSelector(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("isLogged");
    }) || false;
    var userInfo = ((ref = useSelector(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("userInfo");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var pageLoadEvent = MetricsCollector.create({
        name: "pageload"
    });
    pageLoadEvent.addPlugin(MetricsCollector.SessionStudentPlugin);
    useEffect(function() {
        if (sendEvent) return;
        var location = window.location;
        var payload = {
            page: "schools",
            path_info: location.pathname,
            place_url: location.href,
            query_string: location.search
        };
        if (isLogged) {
            if (userInfo.userId !== 0) {
                payload = _object_spread_props(_object_spread({}, payload), {
                    email: userInfo.email,
                    name: userInfo.name,
                    user_type: userInfo.userType,
                    uuid: userInfo.userId
                });
                pageLoadEvent.send(payload);
                sendEvent = true;
            }
        } else {
            pageLoadEvent.send(payload);
            sendEvent = true;
        }
    }, [
        userInfo
    ]);
    useEffect(function() {
        if (!sendAnalyticsEvent) {
            Track.send({
                event: "schools_experiment_community",
                cookie: "A"
            });
            sendAnalyticsEvent = true;
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs(BaseLayout, {
            isDark: true,
            children: [
                /*#__PURE__*/ _jsx(Header, {}),
                /*#__PURE__*/ _jsx(Dropdown, {}),
                /*#__PURE__*/ _jsx(PlacementTest, {}),
                /*#__PURE__*/ _jsx(Routes, {}),
                /*#__PURE__*/ _jsx(WhatIsSchool, {}),
                /*#__PURE__*/ _jsx(Community, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/ModalPortal-3d0cff28.js
var ModalPortal_3d0cff28 = __webpack_require__(4175);
// EXTERNAL MODULE: ./node_modules/@platzi/micro-ui.whatsapp-button/dist/es/index.js + 1 modules
var dist_es = __webpack_require__(8253);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/index-097a0a02.js + 1 modules
var index_097a0a02 = __webpack_require__(8888);
// EXTERNAL MODULE: ./src/components/shared/PricingTable/index.ts + 1 modules
var PricingTable = __webpack_require__(2555);
;// CONCATENATED MODULE: ./src/components/escuela/Layout/LayoutCommunity.tsx










var LayoutCommunity_sendEvent = false;
var LayoutCommunity_sendAnalyticsEvent = false;
var LayoutCommunity_LayoutCommunity = function() {
    var ref;
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("isLogged");
    }) || false;
    var userInfo = ((ref = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("userInfo");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var ref1 = (0,react.useState)(false), showCommunity = ref1[0], setShowCommunity = ref1[1];
    var pageLoadEvent = index_097a0a02.l.create({
        name: "pageload"
    });
    pageLoadEvent.addPlugin(index_097a0a02.l.SessionStudentPlugin);
    (0,react.useEffect)(function() {
        if (LayoutCommunity_sendEvent) return;
        var location = window.location;
        var payload = {
            page: "schools",
            path_info: location.pathname,
            place_url: location.href,
            query_string: location.search
        };
        if (isLogged) {
            if (userInfo.userId !== 0) {
                payload = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, payload), {
                    email: userInfo.email,
                    name: userInfo.name,
                    user_type: userInfo.userType,
                    uuid: userInfo.userId
                });
                pageLoadEvent.send(payload);
                LayoutCommunity_sendEvent = true;
            }
        } else {
            pageLoadEvent.send(payload);
            LayoutCommunity_sendEvent = true;
        }
    }, [
        userInfo
    ]);
    (0,react.useEffect)(function() {
        if (!LayoutCommunity_sendAnalyticsEvent) {
            index_097a0a02.q.send({
                event: "schools_experiment_community",
                cookie: "B"
            });
            LayoutCommunity_sendAnalyticsEvent = true;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPortal_3d0cff28.B, {
            isDark: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCommunity, {
                    clickOnTab: setShowCommunity,
                    showCommunity: showCommunity
                }),
                !showCommunity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacementTest_PlacementTest, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Routes_Routes, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingTable/* PricingTable */.b, {})
                    ]
                }),
                showCommunity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Community_Community, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* default */.Z, {
                    user: isLogged ? userInfo : null
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Experiment/Experiment.tsx




var Experiment = function() {
    var ref = useState(""), cookieValue = ref[0], setCookieValue = ref[1];
    var getRandom = function() {
        var r = Math.random() * 100;
        if (r <= 50) return "A";
        return "B";
    };
    useEffect(function() {
        var currentCookie = getCookie("lear-SCH5254");
        if (currentCookie === undefined) {
            var newCookie = getRandom();
            setCookie("lear-SCH5254", newCookie, 600000);
            setCookieValue(newCookie);
        } else {
            setCookieValue(currentCookie);
        }
    }, []);
    if (cookieValue === "A") {
        return /*#__PURE__*/ _jsx(Layout, {});
    }
    if (cookieValue === "B") {
        return /*#__PURE__*/ _jsx(LayoutCommunity, {});
    }
};

// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/utils/definitions.ts
var definitions_schoolBanner = {
    5: "https://static.platzi.com/media/uploads/school_bg_computerscience_2x_efd708987d.png?updated_at=2022-08-11T13:58:02.011Z",
    6: "https://static.platzi.com/media/uploads/school_bg_design_2x_0e76dc2cb5.png?updated_at=2022-08-11T13:58:02.098Z",
    7: "https://static.platzi.com/media/uploads/school_bg_marketing_2x_a501fe11b8.png?updated_at=2022-08-11T13:58:03.016Z",
    8: "https://static.platzi.com/media/uploads/school_bg_business_2x_cd61dfd710.png?updated_at=2022-08-11T13:58:01.711Z",
    10: "https://static.platzi.com/media/uploads/school_bg_digitalcontent_2x_200b13abd4.png?updated_at=2022-08-11T13:58:02.304Z",
    11: "https://static.platzi.com/media/uploads/school_bg_softskills_2x_fa7eb1d857.png?updated_at=2022-08-11T13:58:03.033Z",
    16: "https://static.platzi.com/media/uploads/school_bg_startups_2x_9008b78e5d.png?updated_at=2022-08-11T13:58:03.097Z",
    17: "https://static.platzi.com/media/uploads/school_bg_english_2x_b9628900b5.png?updated_at=2022-08-11T13:58:03.039Z",
    50: "https://static.platzi.com/media/uploads/school_bg_design_2x_0e76dc2cb5.png?updated_at=2022-08-11T13:58:02.098Z",
    51: "https://static.platzi.com/media/uploads/school_bg_digitalcontent_2x_200b13abd4.png?updated_at=2022-08-11T13:58:02.304Z",
    52: "https://static.platzi.com/media/uploads/school_bg_business_2x_cd61dfd710.png?updated_at=2022-08-11T13:58:01.711Z",
    53: "https://static.platzi.com/media/uploads/school_bg_softskills_2x_fa7eb1d857.png?updated_at=2022-08-11T13:58:03.033Z",
    54: "https://static.platzi.com/media/uploads/school_bg_marketing_2x_a501fe11b8.png?updated_at=2022-08-11T13:58:03.016Z",
    55: "https://static.platzi.com/media/uploads/school_bg_computerscience_2x_efd708987d.png?updated_at=2022-08-11T13:58:02.011Z",
    56: "https://static.platzi.com/media/uploads/school_bg_startups_2x_9008b78e5d.png?updated_at=2022-08-11T13:58:03.097Z",
    57: "https://static.platzi.com/media/uploads/school_bg_english_2x_b9628900b5.png?updated_at=2022-08-11T13:58:03.039Z"
};

// EXTERNAL MODULE: ./src/env.ts
var env = __webpack_require__(3223);
;// CONCATENATED MODULE: ./src/utils/imageOptimizer.ts

var getOptimizedImage = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? 1080 : _width, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    var params = "".concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality);
    return "".concat(env/* DOMAIN */.yK, "/_next/image?url=").concat(params);
};
var imageOptimizer_imageLoader = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? 1080 : _width, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _format = param.format, format = _format === void 0 ? "auto" : _format;
    if (src.includes("/_next/")) return src;
    if (!src.includes("static.platzi.com") && !src.includes("platzistaging.s3.amazonaws.com")) return getOptimizedImage({
        src: src,
        width: width,
        quality: quality
    });
    var url = new URL(src);
    var pathname = url.pathname;
    var params = "cdn-cgi/image/width=".concat(width, ",quality=").concat(quality, ",format=").concat(format);
    return "".concat(env/* IMAGE_RESIZER_URL */.Pz, "/").concat(params).concat(pathname);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(2814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__(2825);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-4abe4715.js
var index_4abe4715 = __webpack_require__(4230);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Input-49ba9375.js
var Input_49ba9375 = __webpack_require__(574);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Button-843a7058.js
var Button_843a7058 = __webpack_require__(3893);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-db686dce.js
var index_db686dce = __webpack_require__(5358);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/useQueryParam-7b678fd6.js
var useQueryParam_7b678fd6 = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/constants.js
var constants = __webpack_require__(160);
// EXTERNAL MODULE: ./src/api/index.ts
var api = __webpack_require__(4196);
// EXTERNAL MODULE: ./src/components/escuela/Header/Form.module.sass
var Form_module = __webpack_require__(455);
var Form_module_default = /*#__PURE__*/__webpack_require__.n(Form_module);
;// CONCATENATED MODULE: ./src/components/escuela/Header/Form.tsx












var Form_Form = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,useQueryParam_7b678fd6.b)("userEmail", ""), 2), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var handleSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (value.trim() <= 0 || !constants/* emailRegex.test */.HN.test(value.toLowerCase().trim())) {
            return setError("escuela.form.error");
        } else {
            setIsLoading(true);
            var formData = new FormData();
            formData.append("email", value);
            formData.append("origin", "schools");
            formData.append("full_path", window.location.href);
            (0,api/* saveEmail */.it)(formData).then(function() {
                return window.location.href = "/onboarding";
            }).catch(function(err) {
                throw new Error("::ERROR::SCHOOLS__HEADER__FORM", {
                    cause: err
                });
            });
        }
    };
    var handleChange = function(event) {
        setValue(event.target.value);
        setError("");
    };
    var CtaFormInputsClasses = classnames_default()((0,_define_property/* default */.Z)({}, (Form_module_default()).InputError, error.length > 0));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (Form_module_default()).Form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("escuela.form.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("escuela.form.copy")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_49ba9375.I, {
                    customClass: CtaFormInputsClasses,
                    placeholder: t("escuela.form.placeholder"),
                    type: "email",
                    name: "email",
                    value: value,
                    handleChange: handleChange,
                    "aria-label": t("escuela.form.placeholder")
                }),
                error.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (Form_module_default()).Error,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_regular_svg_icons_index_es/* faExclamationTriangle */.eHv
                        }),
                        " ",
                        t("escuela.form.error")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_843a7058.B, {
                    hierarchy: "primary",
                    color: "platzi",
                    onClick: handleSubmit,
                    children: [
                        t("escuela.form.button"),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_db686dce.L, {
                            customStyle: (Form_module_default()).loader
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Header/index.ts


// EXTERNAL MODULE: ./src/components/shared/Share/index.ts + 3 modules
var Share = __webpack_require__(5065);
// EXTERNAL MODULE: ./src/components/escuela/FollowSchool/FollowModal.module.sass
var FollowModal_module = __webpack_require__(2945);
var FollowModal_module_default = /*#__PURE__*/__webpack_require__.n(FollowModal_module);
;// CONCATENATED MODULE: ./src/components/escuela/FollowSchool/FollowModal.tsx







var FollowModal = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    if (!props.showModal) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (FollowModal_module_default()).Modal,
        "data-testid": "modal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_4abe4715.C, {
            isDark: true,
            customClass: (FollowModal_module_default()).Card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (FollowModal_module_default()).CloseModal,
                    type: "button",
                    onClick: function() {
                        return props.closeModal(false);
                    },
                    "aria-label": t("escuela.share.buttonCloseModal"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faTimes */.NBC,
                        size: "sm"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FollowModal_module_default()).CardHead,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_regular_svg_icons_index_es/* faCircleMinus */.W7v
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("escuela.followModal.title")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (FollowModal_module_default()).CardCopy,
                            children: t("escuela.followModal.copy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FollowModal_module_default()).CardFooter,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_843a7058.B, {
                                    customClass: (FollowModal_module_default()).CardCancelar,
                                    onClick: function() {
                                        return props.closeModal(false);
                                    },
                                    children: t("escuela.followModal.buttonCancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_843a7058.B, {
                                    onClick: props.unfollow,
                                    children: t("escuela.followModal.buttonConfirm")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/FollowSchool/FollowSchool.module.sass
var FollowSchool_module = __webpack_require__(9201);
var FollowSchool_module_default = /*#__PURE__*/__webpack_require__.n(FollowSchool_module);
;// CONCATENATED MODULE: ./src/components/escuela/FollowSchool/FollowSchool.tsx












var FollowSchool_FollowSchool = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var schoolId = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("id");
    }) || 1;
    var ref = (0,react.useState)(undefined), userFollowSchool = ref[0], setUserFollowSchool = ref[1];
    var ref1 = (0,react.useState)(0), userSchoolId = ref1[0], setUserSchoolId = ref1[1];
    var ref2 = (0,react.useState)(false), showConfirmationModal = ref2[0], setShowConfirmationModal = ref2[1];
    (0,react.useEffect)(function() {
        (0,api/* getFollowSchools */.CS)().then(function(res) {
            var ref;
            var isFollowing = (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                return item.learningPathId === schoolId;
            });
            if (isFollowing.length > 0) {
                setUserSchoolId(isFollowing[0].id);
                setUserFollowSchool(true);
            } else {
                setUserFollowSchool(false);
            }
        }).catch(function(err) {
            throw new Error("::ERROR::GET_FOLLOW_SCHOOLS", {
                cause: err
            });
        });
    }, []);
    var toggleFollow = function() {
        if (!userFollowSchool) {
            var payload = {
                level: "basic"
            };
            (0,api/* followSchool */.iC)(schoolId, payload).then(function(res) {
                var ref;
                setUserFollowSchool(true);
                setUserSchoolId(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id);
            }).catch(function(err) {
                throw new Error("::ERROR::FOLLOW_SCHOOL", {
                    cause: err
                });
            });
        } else {
            setShowConfirmationModal(true);
        }
    };
    var handleUnfollow = function() {
        setShowConfirmationModal(false);
        (0,api/* unFollowSchool */.mt)(userSchoolId).then(function() {
            return setUserFollowSchool(false);
        }).catch(function(err) {
            throw new Error("::ERROR::UNFOLLOW_SCHOOL", {
                cause: err
            });
        });
    };
    var renderButtonContent = function() {
        if (!userFollowSchool) {
            return t("escuela.followSchool.follow");
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faCircleCheck */.fV7
                    }),
                    t("escuela.followSchool.unfollow")
                ]
            });
        }
    };
    var buttonState = classnames_default()((FollowSchool_module_default()).Button, (0,_define_property/* default */.Z)({}, (FollowSchool_module_default()).Unfollow, userFollowSchool));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            userFollowSchool !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FollowSchool_module_default()).Container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_843a7058.B, {
                        as: "button",
                        onClick: toggleFollow,
                        customClass: buttonState,
                        children: renderButtonContent()
                    }),
                    userFollowSchool && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("escuela.followSchool.help")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowModal, {
                showModal: showConfirmationModal,
                closeModal: setShowConfirmationModal,
                unfollow: handleUnfollow
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/FollowSchool/index.ts


// EXTERNAL MODULE: ./src/hooks/useSignUpModal.tsx
var hooks_useSignUpModal = __webpack_require__(2709);
;// CONCATENATED MODULE: ./src/components/escuela/Header/Header.tsx












var Header_Header = function() {
    var ref;
    var t = useTranslation().t;
    var ref1 = useSignUpModal(), openSignup = ref1.openSignup, SignUpComponent = ref1.SignUpComponent;
    var school = ((ref = useSelector(function(state) {
        return state.get("school");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var isLogged = useSelector(function(state) {
        return state.get("header");
    }).get("isLogged") || false;
    var hero = school.hero, school_category = school.school_category, color_dark = school.color_dark;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.Header,
        style: {
            backgroundImage: "url(".concat(schoolBanner[school_category], ")")
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "".concat(styles.HeaderGrid, " u-wrapper"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.HeaderHead,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.HeaderHeadTop,
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            loader: imageLoader,
                                            src: hero.badge,
                                            alt: hero.title,
                                            width: 68,
                                            height: 68
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    color: color_dark
                                                },
                                                children: t("escuela.header.label")
                                            }),
                                            /*#__PURE__*/ _jsx("h1", {
                                                children: hero.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.HeaderHeadSubtitle,
                                children: hero.subtitle
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.HeaderButtons,
                                children: [
                                    isLogged ? /*#__PURE__*/ _jsx(FollowSchool, {}) : /*#__PURE__*/ _jsx("button", {
                                        onClick: openSignup,
                                        className: styles.BuyButton,
                                        children: "Crea una cuenta y empieza ya"
                                    }),
                                    /*#__PURE__*/ _jsx(ShareButton, {
                                        isLogged: isLogged,
                                        messages: {
                                            isLogged: t("escuela.share.buttonToShareShort"),
                                            notLogged: t("escuela.share.buttonToShare"),
                                            sharedCopy: t("escuela.share.copy")
                                        },
                                        socialNetworkTitle: hero.title
                                    })
                                ]
                            })
                        ]
                    }),
                    !isLogged && /*#__PURE__*/ _jsx("div", {
                        className: styles.HeaderForm,
                        children: /*#__PURE__*/ _jsx(Form, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SignUpComponent, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/DynamicHTML-c18b6504.js
var DynamicHTML_c18b6504 = __webpack_require__(8318);
// EXTERNAL MODULE: ./src/components/escuela/Header/HeaderCommunity.module.sass
var HeaderCommunity_module = __webpack_require__(29);
var HeaderCommunity_module_default = /*#__PURE__*/__webpack_require__.n(HeaderCommunity_module);
;// CONCATENATED MODULE: ./src/components/escuela/Header/HeaderCommunity.tsx












var HeaderCommunity = function(props) {
    var ref;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,hooks_useSignUpModal/* default */.Z)(), openSignup = ref1.openSignup, SignUpComponent = ref1.SignUpComponent;
    var school = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header");
    }).get("isLogged") || false;
    var hero = school.hero, school_category = school.school_category, color_dark = school.color_dark;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HeaderCommunity_module_default()).HeaderCommunity,
        style: {
            backgroundImage: "url(".concat(definitions_schoolBanner[school_category], ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((HeaderCommunity_module_default()).HeaderGrid, " u-wrapper"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeaderCommunity_module_default()).HeaderHead,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HeaderCommunity_module_default()).HeaderHeadTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            loader: imageOptimizer_imageLoader,
                                            src: hero.badge,
                                            alt: hero.title,
                                            width: 68,
                                            height: 68
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: color_dark
                                                },
                                                children: t("escuela.header.label")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: hero.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHTML_c18b6504.D, {
                                className: (HeaderCommunity_module_default()).HeaderHeadSubtitle,
                                tag: "p",
                                html: hero.subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeaderCommunity_module_default()).HeaderButtons,
                                children: isLogged ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowSchool_FollowSchool, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: openSignup,
                                    className: (HeaderCommunity_module_default()).BuyButton,
                                    children: "Crea una cuenta y empieza ya"
                                })
                            })
                        ]
                    }),
                    !isLogged && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeaderCommunity_module_default()).HeaderForm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Form, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((HeaderCommunity_module_default()).Tabs, " u-wrapper"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: !props.showCommunity ? (HeaderCommunity_module_default()).Active : undefined,
                                onClick: function() {
                                    return props.clickOnTab(!props.showCommunity);
                                },
                                children: t("escuela.headerCommunity.routes")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: props.showCommunity ? (HeaderCommunity_module_default()).Active : undefined,
                                onClick: function() {
                                    return props.clickOnTab(!props.showCommunity);
                                },
                                children: t("escuela.headerCommunity.community")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpComponent, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Routes/RoutesHeader.module.sass
var RoutesHeader_module = __webpack_require__(8171);
var RoutesHeader_module_default = /*#__PURE__*/__webpack_require__.n(RoutesHeader_module);
;// CONCATENATED MODULE: ./src/components/escuela/Routes/RoutesHeader.tsx





var RoutesHeader = function(param) {
    var showTabs = param.showTabs, description = param.description;
    var ref;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var learningPaths = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("tabLp");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var intersectionOptions = {
        root: null,
        rootMargin: "-20% 0px -70% 0px",
        threshold: 0
    };
    var callbackIntersection = function(entries) {
        entries.forEach(function(entry) {
            var id = entry.target.id;
            var element = document.querySelector('[href="#'.concat(id, '"]'));
            if (entry.intersectionRatio > 0) {
                element && element.classList.add((RoutesHeader_module_default()).active);
            } else {
                element && element.classList.remove((RoutesHeader_module_default()).active);
            }
        });
    };
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(callbackIntersection, intersectionOptions);
        var sections = document.querySelectorAll("#Routes section");
        sections.forEach(function(element) {
            return observer.observe(element);
        });
        return function() {
            return sections.forEach(function(element) {
                return observer.unobserve(element);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RoutesHeader_module_default()).RoutesHeader,
        children: showTabs ? /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: learningPaths.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#lp".concat(index, "-").concat(encodeURI(item.title)),
                            children: item.title
                        })
                    }, "lp-".concat(index));
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: description
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__(2565);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-c7a61e91.js
var index_c7a61e91 = __webpack_require__(4522);
// EXTERNAL MODULE: ./src/components/escuela/Routes/RoutesCard.module.sass
var RoutesCard_module = __webpack_require__(6630);
var RoutesCard_module_default = /*#__PURE__*/__webpack_require__.n(RoutesCard_module);
;// CONCATENATED MODULE: ./src/components/escuela/Routes/RoutesCard.tsx











var RoutesCard = function(props) {
    var ref, ref1;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("isLogged");
    }) || false;
    var color = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("color_dark");
    }) || "";
    var ref2 = (0,react.useState)(""), school = ref2[0], setShool = ref2[1];
    var percentageCompleted = (ref = props.progress) === null || ref === void 0 ? void 0 : ref.percentage;
    (0,react.useEffect)(function() {
        var queryString = window.location.pathname.replaceAll("/", "_");
        setShool(queryString);
    }, []);
    var renderFooter = function() {
        if (percentageCompleted === 0 || isLogged === false) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_843a7058.B, {
                customClass: (RoutesCard_module_default()).RoutesCardButton,
                as: "a",
                href: "".concat(props.url, "?school=").concat(school),
                color: "sky",
                hierarchy: "secondary",
                children: t("escuela.routesCard.btn")
            });
        }
        if (percentageCompleted === 100) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_c7a61e91.P, {
                        customClass: (RoutesCard_module_default()).RoutesCardProgressBar,
                        percentageReached: (ref = props.progress) === null || ref === void 0 ? void 0 : ref.percentage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                className: (RoutesCard_module_default()).RouteCompleted,
                                icon: pro_regular_svg_icons_index_es/* faCircleCheck */.fV7
                            }),
                            " ",
                            t("escuela.routesCard.completed")
                        ]
                    })
                ]
            });
        }
        if (percentageCompleted < 100) {
            var ref1, ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_c7a61e91.P, {
                        customClass: (RoutesCard_module_default()).RoutesCardProgressBar,
                        percentageReached: (ref1 = props.progress) === null || ref1 === void 0 ? void 0 : ref1.percentage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                className: (RoutesCard_module_default()).RouteInProgress,
                                icon: pro_regular_svg_icons_index_es/* faAward */.O7Q
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: t("escuela.routesCard.inProgress", {
                                        count: (ref2 = props.progress) === null || ref2 === void 0 ? void 0 : ref2.approvedCoursesCount
                                    })
                                }
                            })
                        ]
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (RoutesCard_module_default()).RoutesCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "".concat(props === null || props === void 0 ? void 0 : props.url, "?school=").concat(school),
            className: (RoutesCard_module_default()).RoutesCardLink,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RoutesCard_module_default()).RoutesCardContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RoutesCard_module_default()).RoutesCardProfesional,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: color
                                    },
                                    children: t("escuela.routesCard.label")
                                }),
                                (props === null || props === void 0 ? void 0 : props.isProfessional) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons_index_es/* faBadgeCheck */.fix
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: props === null || props === void 0 ? void 0 : props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: props === null || props === void 0 ? void 0 : props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RoutesCard_module_default()).RoutesCardData,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RoutesCard_module_default()).RoutesCardCourses,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_regular_svg_icons_index_es/* faPlus */.r8p
                                            })
                                        }),
                                        props === null || props === void 0 ? void 0 : (ref1 = props.courses) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((image_default()), {
                                                loader: imageOptimizer_imageLoader,
                                                src: item === null || item === void 0 ? void 0 : item.image,
                                                alt: item === null || item === void 0 ? void 0 : item.title,
                                                width: 24,
                                                height: 24
                                            }, "courseImage-".concat(index));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: props === null || props === void 0 ? void 0 : props.totalOfCourses
                                        }),
                                        " ",
                                        t("escuela.routesCard.courses")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (RoutesCard_module_default()).RoutesCardDivisor,
                                    children: "•"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: props === null || props === void 0 ? void 0 : props.duration
                                        }),
                                        " ",
                                        t("escuela.routesCard.hours")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RoutesCard_module_default()).RoutesCardFooter,
                            children: renderFooter()
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Routes/RoutesSection.module.sass
var RoutesSection_module = __webpack_require__(432);
var RoutesSection_module_default = /*#__PURE__*/__webpack_require__.n(RoutesSection_module);
;// CONCATENATED MODULE: ./src/components/escuela/Routes/RoutesSection.tsx





var RoutesSection = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (RoutesSection_module_default()).RoutesSection,
        id: "lp".concat(props === null || props === void 0 ? void 0 : props.index, "-").concat(encodeURI(props === null || props === void 0 ? void 0 : props.title)),
        "data-testid": "RoutesSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (RoutesSection_module_default()).RoutesSectionContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (RoutesSection_module_default()).RoutesSectionDescription,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props === null || props === void 0 ? void 0 : props.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: props === null || props === void 0 ? void 0 : props.description
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (RoutesSection_module_default()).RoutesSectionCards,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: props === null || props === void 0 ? void 0 : (ref = props.routes) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(RoutesCard, (0,src_object_spread/* default */.Z)({
                                    progress: props === null || props === void 0 ? void 0 : (ref = props.routesProgress) === null || ref === void 0 ? void 0 : ref[item === null || item === void 0 ? void 0 : item.id]
                                }, item), "routeCard-".concat(index));
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Routes/RoutesSimpleSection.module.sass
var RoutesSimpleSection_module = __webpack_require__(1862);
var RoutesSimpleSection_module_default = /*#__PURE__*/__webpack_require__.n(RoutesSimpleSection_module);
;// CONCATENATED MODULE: ./src/components/escuela/Routes/RoutesSimpleSection.tsx





var RoutesSimpleSection = function(param) {
    var learningPath = param.learningPath, routesProgress = param.routesProgress;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (RoutesSimpleSection_module_default()).RoutesSimpleSection,
        "data-testid": "RoutesSimpleSection",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (RoutesSimpleSection_module_default()).Grid,
            children: learningPath.routes.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoutesCard, (0,src_object_spread/* default */.Z)({
                    progress: routesProgress[item.id]
                }, item), "routeCard-".concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Routes/index.ts





// EXTERNAL MODULE: ./src/components/escuela/Routes/Routes.module.sass
var Routes_module = __webpack_require__(3565);
var Routes_module_default = /*#__PURE__*/__webpack_require__.n(Routes_module);
;// CONCATENATED MODULE: ./src/components/escuela/Routes/Routes.tsx








var Routes_Routes = function() {
    var ref, ref1;
    var learningPaths = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("tabLp");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("isLogged");
    }) || false;
    var hasMultipleLearningPaths = learningPaths.length > 1;
    var ref2 = (0,react.useState)({}), routesProgress = ref2[0], setRoutesProgress = ref2[1];
    (0,react.useEffect)(function() {
        if (isLogged) {
            var schoolSlug = window.location.pathname.replaceAll("/escuela/", "");
            (0,api/* getRoutesProgress */.Lx)(schoolSlug).then(function(res) {
                return setRoutesProgress(res.data);
            }).catch(function(err) {
                throw new Error("::ERROR::SCHOOL__ROUTES", {
                    cause: err
                });
            });
        }
    }, [
        isLogged
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Routes_module_default()).Routes,
        id: "Routes",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "u-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoutesHeader, {
                    showTabs: hasMultipleLearningPaths,
                    description: learningPaths === null || learningPaths === void 0 ? void 0 : (ref1 = learningPaths[0]) === null || ref1 === void 0 ? void 0 : ref1.description
                }),
                hasMultipleLearningPaths ? learningPaths === null || learningPaths === void 0 ? void 0 : learningPaths.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoutesSection, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        routesProgress: routesProgress
                    }, item), {
                        index: index
                    }), "lsSection-".concat(index));
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RoutesSimpleSection, {
                    routesProgress: routesProgress,
                    learningPath: learningPaths[0]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/WhatIsSchool/WhatIsSchool.tsx










var WhatIsSchool_WhatIsSchool = function() {
    var t = useTranslation().t;
    var ref = _sliced_to_array(useLocalStorage("WhatIs", "true"), 2), showContent = ref[0], setShowContent = ref[1];
    var handleContent = function() {
        return setShowContent(showContent === "true" ? "false" : "true");
    };
    if (showContent === "false") return null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.WhatIsSchool,
        children: /*#__PURE__*/ _jsx("div", {
            className: "u-wrapper",
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.Card,
                style: {
                    backgroundImage: "url(https://static.platzi.com/media/uploads/thumbnail_school_bg_marketing_2x_a501fe11b8.png)"
                },
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        loader: imageLoader,
                        src: "https://static.platzi.com/media/uploads/whatis2x_05b814b167.png",
                        alt: t("escuela.whatIs.title"),
                        width: 161,
                        height: 192
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h6", {
                                children: t("escuela.whatIs.title")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: t("escuela.whatIs.copy")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: handleContent,
                        children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: faXmark
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/WhatIsSchool/index.ts


// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Carousel-ab5c2628.js
var Carousel_ab5c2628 = __webpack_require__(5743);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCommentAlt.js
var faCommentAlt = __webpack_require__(2066);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faHeart.js
var faHeart = __webpack_require__(3829);
// EXTERNAL MODULE: ./src/components/escuela/Blogposts/BlogpostsCard.module.sass
var BlogpostsCard_module = __webpack_require__(3358);
var BlogpostsCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogpostsCard_module);
;// CONCATENATED MODULE: ./src/components/escuela/Blogposts/BlogpostsCard.tsx









var BlogpostsCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (BlogpostsCard_module_default()).BlogpostsCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: props.url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: imageOptimizer_imageLoader,
                        src: props.image,
                        alt: props.title,
                        width: 268,
                        height: 112
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BlogpostsCard_module_default()).Body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BlogpostsCard_module_default()).Author,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    loader: imageOptimizer_imageLoader,
                                    src: props.authorData.avatar,
                                    alt: props.authorData.public_name,
                                    width: 39,
                                    height: 39
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: props.authorData.public_name
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BlogpostsCard_module_default()).Community,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: faHeart/* faHeart */.m6
                                }),
                                " ",
                                props.likes
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "•"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: faCommentAlt/* faCommentAlt */.Eg
                                }),
                                " ",
                                props.comments
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Blogposts/Blogposts.module.sass
var Blogposts_module = __webpack_require__(1649);
var Blogposts_module_default = /*#__PURE__*/__webpack_require__.n(Blogposts_module);
;// CONCATENATED MODULE: ./src/components/escuela/Blogposts/Blogposts.tsx











var Blogposts = function() {
    var ref;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var content = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("community").get("tabCommunity").get("blogposts");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || [];
    var ref1 = (0,react.useState)("popular"), contentToShow = ref1[0], setContentToShow = ref1[1];
    if (content.populars.length === 0) return null;
    var renderCards = function() {
        switch(contentToShow){
            case "popular":
                var ref;
                return (ref = content.populars) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogpostsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolBlog-".concat(index));
                });
            case "new":
                var ref1;
                return (ref1 = content.news) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogpostsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolBlog-".concat(index));
                });
            default:
                var ref2;
                return (ref2 = content.populars) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogpostsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolBlog-".concat(index));
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Blogposts_module_default()).Blogposts,
        id: "blogposts",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection_TitleSection, {
                title: t("escuela.blogposts.title"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (Blogposts_module_default()).Link,
                    href: "/blog/",
                    children: [
                        t("escuela.blogposts.link"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_regular_svg_icons_index_es/* faArrowRight */.eFW
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                handleClick: setContentToShow,
                activeTab: contentToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_ab5c2628.C, {
                elements: renderCards()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Blogposts/index.ts


// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/index-e9a6ce7d.js + 2 modules
var index_e9a6ce7d = __webpack_require__(3099);
// EXTERNAL MODULE: ./src/services/api/index.ts + 1 modules
var services_api = __webpack_require__(6394);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Image-ee36dcbe.js
var Image_ee36dcbe = __webpack_require__(4357);
// EXTERNAL MODULE: ./src/components/escuela/Challenges/ChallengesCard.module.sass
var ChallengesCard_module = __webpack_require__(443);
var ChallengesCard_module_default = /*#__PURE__*/__webpack_require__.n(ChallengesCard_module);
;// CONCATENATED MODULE: ./src/components/escuela/Challenges/ChallengesCard.tsx









var ChallengesCard = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("locale");
    });
    var isBrasil = locale === constants/* LOCALES.PORTUGUESE */.lE.PORTUGUESE;
    var cardUrl = isBrasil ? "/desafios/".concat(props.slug, "/") : "/retos/".concat(props.slug, "/");
    var handleStatusMessage = function() {
        switch(props.status){
            case "joined":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (ChallengesCard_module_default()).Joined,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons_index_es/* faCheckCircle */.f8k
                        }),
                        t("escuela.challengesCard.joined")
                    ]
                });
            case "plan_required":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("escuela.challengesCard.readyToJoin")
                });
            case "ready_to_join":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("escuela.challengesCard.readyToJoin")
                });
            case "closed":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (ChallengesCard_module_default()).closed,
                    children: t("escuela.challengesCard.closed")
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (ChallengesCard_module_default()).closed,
                    children: t("escuela.challengesCard.closed")
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (ChallengesCard_module_default()).ChallengesCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: cardUrl,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ee36dcbe.I, {
                        src: props === null || props === void 0 ? void 0 : props.thumbnail,
                        alt: props === null || props === void 0 ? void 0 : props.title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ChallengesCard_module_default()).Content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: props === null || props === void 0 ? void 0 : props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: props === null || props === void 0 ? void 0 : props.description
                        }),
                        handleStatusMessage()
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Challenges/Challenges.module.sass
var Challenges_module = __webpack_require__(9823);
var Challenges_module_default = /*#__PURE__*/__webpack_require__.n(Challenges_module);
;// CONCATENATED MODULE: ./src/components/escuela/Challenges/Challenges.tsx











var Challenges = function(props) {
    var RoutesIds = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("lps_ids");
    }).toJS() || [];
    var ref = (0,react.useState)([]), challenges = ref[0], setChallenges = ref[1];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var elementsByBreakpoint = {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 2
    };
    (0,react.useEffect)(function() {
        (0,index_e9a6ce7d.c)("challenges", {
            method: "get",
            requestURL: services_api/* schoolsApi.client.schools.challenges */.b.client.schools.challenges(RoutesIds.toString())
        }).then(function(res) {
            setChallenges(res);
            props.setShowChallenges(res.length > 0);
        }).catch(function(err) {
            throw new Error("::ERROR::SCHOOL__CHALLENGES", {
                cause: err
            });
        });
    }, []);
    if (challenges.length === 0) {
        return null;
    }
    var renderCards = function() {
        return challenges.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolChallenge-".concat(index));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Challenges_module_default()).Challenges,
        id: "challenges",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection_TitleSection, {
                title: t("escuela.challenges.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_ab5c2628.C, {
                numberOfElements: elementsByBreakpoint,
                elements: renderCards()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Challenges/index.ts


// EXTERNAL MODULE: ./src/components/escuela/Community/Community.module.sass
var Community_module = __webpack_require__(9625);
var Community_module_default = /*#__PURE__*/__webpack_require__.n(Community_module);
;// CONCATENATED MODULE: ./src/components/escuela/Community/Community.tsx





var Community_Community = function() {
    var ref;
    var schoolTitle = (0,es/* useSelector */.v9)(function(state) {
        return state.get("school").get("hero").get("title");
    });
    var communityContent = (ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("community").get("tabCommunity");
    })) === null || ref === void 0 ? void 0 : ref.toJS();
    var ref1 = (0,react.useState)(false), showChallenges = ref1[0], setShowChallenges = ref1[1];
    var ref2 = (0,react.useState)(false), showAnchors = ref2[0], setShowAnchors = ref2[1];
    var intersectionOptions = {
        root: null,
        rootMargin: "-20% 0px -70% 0px",
        threshold: 0
    };
    var callbackIntersection = function(entries) {
        entries.forEach(function(entry) {
            var id = entry.target.id;
            var element = document.querySelector('[href="#'.concat(id, '"]'));
            if (entry.intersectionRatio > 0) {
                element && element.classList.add((Community_module_default()).active);
            } else {
                element && element.classList.remove((Community_module_default()).active);
            }
        });
    };
    var renderLink = function(link, copy) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: link,
                children: copy
            })
        });
    };
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(callbackIntersection, intersectionOptions);
        var sections = document.querySelectorAll("#Community section");
        sections.forEach(function(element) {
            return observer.observe(element);
        });
        if (sections.length > 1) setShowAnchors(true);
        return function() {
            return sections.forEach(function(element) {
                return observer.unobserve(element);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (Community_module_default()).Community,
        id: "Community",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "u-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Community_module_default()).Top,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                            children: [
                                "Comunidad de ",
                                schoolTitle
                            ]
                        }),
                        showAnchors && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    communityContent.blogposts.populars.length > 0 && renderLink("#blogposts", "Blogposts"),
                                    showChallenges && renderLink("#challenges", "Retos"),
                                    communityContent.projects.length > 0 && renderLink("#projects", "Proyectos"),
                                    communityContent.tutorials.populars.length > 0 && renderLink("#tutorials", "Tutoriales")
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Blogposts, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Challenges, {
                    setShowChallenges: setShowChallenges
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Projects, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tutorials, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Community/index.ts


;// CONCATENATED MODULE: ./src/components/escuela/LiveEvents/LiveEvents.tsx







var LiveEvents = function() {
    var Mock = new Array(6).fill("");
    var elementsByBreakpoint = {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 3
    };
    var renderCards = function() {
        return Mock.map(function(item, index) {
            return /*#__PURE__*/ _jsx("div", {
                children: "Live Event"
            }, "SchoolLiveEvent-".concat(index));
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.LiveEvents,
        children: [
            /*#__PURE__*/ _jsx(TitleSection, {
                title: "Live Events",
                children: /*#__PURE__*/ _jsxs("a", {
                    className: styles.Link,
                    href: "?",
                    children: [
                        "Ir a Eventos ",
                        /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: faArrowRight
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                numberOfElements: elementsByBreakpoint,
                elements: renderCards()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/LiveEvents/index.ts


// EXTERNAL MODULE: ./src/components/escuela/Projects/ProjectsCard.module.sass
var ProjectsCard_module = __webpack_require__(7333);
var ProjectsCard_module_default = /*#__PURE__*/__webpack_require__.n(ProjectsCard_module);
;// CONCATENATED MODULE: ./src/components/escuela/Projects/ProjectsCard.tsx





var ProjectsCard = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (ProjectsCard_module_default()).ProjectsCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ee36dcbe.I, {
                        alt: props.title,
                        src: props.image
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProjectsCard_module_default()).Content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ProjectsCard_module_default()).Title,
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProjectsCard_module_default()).UserInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ee36dcbe.I, {
                                    alt: props.user.public_name,
                                    src: props.user.avatar
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: props.user.public_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("escuela.projectsCard.time-".concat(props.time_data.time_type), {
                                                count: props.time_data.time
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Projects/Projects.module.sass
var Projects_module = __webpack_require__(6754);
var Projects_module_default = /*#__PURE__*/__webpack_require__.n(Projects_module);
;// CONCATENATED MODULE: ./src/components/escuela/Projects/Projects.tsx









var Projects = function() {
    var ref;
    var content = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("community").get("tabCommunity").get("projects");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || [];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    if (content.length === 0) return null;
    var renderCards = function() {
        return content.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolProject-".concat(index));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Projects_module_default()).Projects,
        id: "projects",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection_TitleSection, {
                title: t("escuela.projects.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_ab5c2628.C, {
                elements: renderCards()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Projects/index.ts


// EXTERNAL MODULE: ./src/components/escuela/Tutorials/TutorialsCard.module.sass
var TutorialsCard_module = __webpack_require__(8015);
var TutorialsCard_module_default = /*#__PURE__*/__webpack_require__.n(TutorialsCard_module);
;// CONCATENATED MODULE: ./src/components/escuela/Tutorials/TutorialsCard.tsx










var TutorialsCard = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4abe4715.C, {
        isDark: true,
        customClass: (TutorialsCard_module_default()).TutorialsCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: props.url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TutorialsCard_module_default()).Content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TutorialsCard_module_default()).Info,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    loader: imageOptimizer_imageLoader,
                                    src: props.authorData.avatar,
                                    alt: props.authorData.public_name,
                                    width: 39,
                                    height: 39
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: props.authorData.public_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("escuela.tutorialsCard.time-".concat(props.createdAt.time_type), {
                                                count: props.createdAt.time
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TutorialsCard_module_default()).Footer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: faHeart/* faHeart */.m6
                                }),
                                " ",
                                props.likes
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "•"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: faCommentAlt/* faCommentAlt */.Eg
                                }),
                                " ",
                                props.comments
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/escuela/Tutorials/Tutorials.module.sass
var Tutorials_module = __webpack_require__(3700);
var Tutorials_module_default = /*#__PURE__*/__webpack_require__.n(Tutorials_module);
;// CONCATENATED MODULE: ./src/components/escuela/Tutorials/Tutorials.tsx









var Tutorials = function() {
    var ref;
    var content = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("community").get("tabCommunity").get("tutorials");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || [];
    var ref1 = (0,react.useState)("popular"), contentToShow = ref1[0], setContentToShow = ref1[1];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var elementsByBreakpoint = {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 3
    };
    if (content.populars.length === 0) return null;
    var renderCards = function() {
        switch(contentToShow){
            case "popular":
                return content.populars.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolTutorial-".concat(index));
                });
            case "new":
                return content.news.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolTutorial-".concat(index));
                });
            default:
                return content.populars.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialsCard, (0,src_object_spread/* default */.Z)({}, item), "SchoolTutorial-".concat(index));
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Tutorials_module_default()).Tutorials,
        id: "tutorials",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection_TitleSection, {
                title: t("escuela.tutorials.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                handleClick: setContentToShow,
                activeTab: contentToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_ab5c2628.C, {
                numberOfElements: elementsByBreakpoint,
                elements: renderCards()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Tutorials/index.ts


// EXTERNAL MODULE: ./src/components/escuela/TitleSection/TitleSection.module.sass
var TitleSection_module = __webpack_require__(8795);
var TitleSection_module_default = /*#__PURE__*/__webpack_require__.n(TitleSection_module);
;// CONCATENATED MODULE: ./src/components/escuela/TitleSection/TitleSection.tsx



var TitleSection_TitleSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TitleSection_module_default()).TitleSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                children: props.title
            }),
            props.children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/TitleSection/index.ts


// EXTERNAL MODULE: ./src/components/escuela/Tabs/Tabs.module.sass
var Tabs_module = __webpack_require__(9111);
var Tabs_module_default = /*#__PURE__*/__webpack_require__.n(Tabs_module);
;// CONCATENATED MODULE: ./src/components/escuela/Tabs/Tabs.tsx




var Tabs = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var options = [
        {
            item: "popular",
            translation: t("escuela.tabs.popular")
        },
        {
            item: "new",
            translation: t("escuela.tabs.new")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Tabs_module_default()).Tabs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: options.map(function(option, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: props.activeTab === option.item && (Tabs_module_default()).Active,
                        onClick: function() {
                            return props.handleClick(option.item);
                        },
                        children: option.translation
                    })
                }, "tab-".concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Tabs/index.ts


;// CONCATENATED MODULE: ./src/components/escuela/Dropdown/Dropdown.tsx









var Dropdown_Dropdown = function() {
    var ref;
    var t = useTranslation().t;
    var header = ((ref = useSelector(function(state) {
        return state.get("school").get("hero");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var ref1 = _sliced_to_array(useLocalStorage("schoolCollapse", "true"), 2), showContent = ref1[0], setShowContent = ref1[1];
    var handleContent = function() {
        return setShowContent(showContent === "true" ? "false" : "true");
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.Dropdown,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "u-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    onClick: handleContent,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: t("escuela.headerDropdown.why", {
                                school: header === null || header === void 0 ? void 0 : header.title
                            })
                        }),
                        /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: showContent === "true" ? faAngleUp : faAngleDown
                        })
                    ]
                }),
                showContent === "true" && /*#__PURE__*/ _jsxs("div", {
                    className: styles.DropdownContent,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: header === null || header === void 0 ? void 0 : header.description
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.DropdownVideo,
                            children: /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("iframe", {
                                    width: "480",
                                    height: "270",
                                    src: header === null || header === void 0 ? void 0 : header.video,
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                    allowFullScreen: true
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/Dropdown/index.ts


// EXTERNAL MODULE: ./src/components/escuela/PlacementTest/PlacementTest.module.sass
var PlacementTest_module = __webpack_require__(355);
var PlacementTest_module_default = /*#__PURE__*/__webpack_require__.n(PlacementTest_module);
;// CONCATENATED MODULE: ./src/components/escuela/PlacementTest/PlacementTest.tsx








var PlacementTest_PlacementTest = function() {
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("isLogged");
    }) || false;
    var schoolId = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("school")) === null || ref === void 0 ? void 0 : ref.get("id");
    }) || 0;
    var ref = (0,react.useState)({}), testContent = ref[0], setTestContent = ref[1];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var isEnglishAcademy = schoolId === 8387;
    (0,react.useEffect)(function() {
        if (isLogged && isEnglishAcademy) {
            var EnglishAcademySlug = "ingles";
            (0,api/* getPlacementTest */.Dl)(EnglishAcademySlug).then(function(res) {
                return setTestContent(res === null || res === void 0 ? void 0 : res.data);
            }).catch(function(err) {
                throw new Error("::ERROR::PLACEMENT_TEST", {
                    cause: err
                });
            });
        }
    }, [
        isLogged,
        isEnglishAcademy
    ]);
    if (!(testContent === null || testContent === void 0 ? void 0 : testContent.showPlacementTest)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PlacementTest_module_default()).PlacementTest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "u-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PlacementTest_module_default()).Content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PlacementTest_module_default()).Message,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (testContent === null || testContent === void 0 ? void 0 : testContent.testTaken) ? (PlacementTest_module_default()).Taken : (PlacementTest_module_default()).Take,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_regular_svg_icons_index_es/* faClipboardCheck */.E9T
                                    })
                                }),
                                (testContent === null || testContent === void 0 ? void 0 : testContent.testTaken) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("escuela.placementTest.taken", {
                                            level: testContent === null || testContent === void 0 ? void 0 : testContent.level
                                        })
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("escuela.placementTest.take")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: testContent === null || testContent === void 0 ? void 0 : testContent.url,
                        children: [
                            (testContent === null || testContent === void 0 ? void 0 : testContent.testTaken) ? t("escuela.placementTest.takenCTA") : t("escuela.placementTest.takeCTA"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_regular_svg_icons_index_es/* faChevronRight */._tD
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/escuela/PlacementTest/index.ts


;// CONCATENATED MODULE: ./src/components/escuela/index.ts


















;// CONCATENATED MODULE: ./src/pages/escuela/[slug]/[locale].tsx



var School = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutCommunity_LayoutCommunity, {});
};
var __N_SSP = true;
/* harmony default export */ var _locale_ = (School);


/***/ }),

/***/ 6394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ schoolsApi; }
});

;// CONCATENATED MODULE: ./src/services/api/schoolsApi.ts
var schoolsApi = {
    server: {
        header: "/api/bff/org/optimized-header/",
        explore: "/api/v5/header-explorer/",
        school: function(slug) {
            return "/api/v5/school/".concat(slug, "/");
        },
        community: function(slug) {
            return "/api/v5/school/".concat(slug, "/community_info/");
        },
        identity: "/api/v5/users/identity/",
        route: function(slug) {
            return "/api/v5/learning-path/".concat(slug, "/");
        },
        contactInfo: "/api/bff/web/contact-info/",
        bannerData: "/api/v5/banner-data/"
    },
    client: {
        schools: {
            getFollowSchools: "/api/v4/user-learning-paths/",
            followSchool: function(schoolId) {
                return "/api/v4/user-learning-paths/".concat(schoolId, "/assign/");
            },
            unFollowSchool: function(schoolId) {
                return "/api/v4/user-learning-paths/".concat(schoolId, "/");
            },
            challenges: function(ids) {
                return "/api/v1/info/?related_learning_path_ids=".concat(ids);
            },
            placement_test: function(schoolSlug) {
                return "/api/v5/school/".concat(schoolSlug, "/placement_test/");
            },
            routesProgress: function(schoolSlug) {
                return "/api/v5/school/".concat(schoolSlug, "school_progress/");
            }
        },
        routes: {
            routeProgress: function(id) {
                return "/api/v5/learning-path/".concat(id, "/progress/");
            }
        },
        registerEmail: "/webhookemail/hola/",
        userPlans: "/api/v4/landing/plans/?hide=b2b_plan",
        tablePrice: "/plans/v1/table-price/",
        b2bPlans: "/api/v4/b2b/landing/plans/"
    }
};

;// CONCATENATED MODULE: ./src/services/api/index.ts



/***/ }),

/***/ 1649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Blogposts":"Blogposts_Blogposts__OjD8U","Link":"Blogposts_Link__DpJ7m"};

/***/ }),

/***/ 3358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BlogpostsCard":"BlogpostsCard_BlogpostsCard__6s6Fh","Body":"BlogpostsCard_Body__bkKlR","Author":"BlogpostsCard_Author__ImG8n","Community":"BlogpostsCard_Community__1YVQg"};

/***/ }),

/***/ 9823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Challenges":"Challenges_Challenges__79MBu"};

/***/ }),

/***/ 443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChallengesCard":"ChallengesCard_ChallengesCard__76jc7","Content":"ChallengesCard_Content___HZiJ","Joined":"ChallengesCard_Joined__8g_0I"};

/***/ }),

/***/ 9625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Community":"Community_Community__hlQuU","active":"Community_active__rhGes","Top":"Community_Top__e0rwn"};

/***/ }),

/***/ 2945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modal":"FollowModal_Modal__XiQZy","CloseModal":"FollowModal_CloseModal__2b4Fj","Card":"FollowModal_Card__dEGSh","CardHead":"FollowModal_CardHead__nKVS4","CardCopy":"FollowModal_CardCopy__HqiZ2","CardFooter":"FollowModal_CardFooter__blneQ","CardCancelar":"FollowModal_CardCancelar__owrYr"};

/***/ }),

/***/ 9201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Container":"FollowSchool_Container__MUDsJ","Button":"FollowSchool_Button__d7PCW","Unfollow":"FollowSchool_Unfollow__ucXWt"};

/***/ }),

/***/ 455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__Ex0Yk","InputError":"Form_InputError__RNppk","Error":"Form_Error__8WewZ","loader":"Form_loader__rqsFW"};

/***/ }),

/***/ 29:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeaderCommunity":"HeaderCommunity_HeaderCommunity__qy8q7","HeaderHead":"HeaderCommunity_HeaderHead__dn92Q","HeaderHeadSubtitle":"HeaderCommunity_HeaderHeadSubtitle__NbaVJ","HeaderHeadTop":"HeaderCommunity_HeaderHeadTop__glIKB","HeaderButtons":"HeaderCommunity_HeaderButtons__34yHp","BuyButton":"HeaderCommunity_BuyButton__c3YO1","HeaderGrid":"HeaderCommunity_HeaderGrid__H0k4m","Tabs":"HeaderCommunity_Tabs__UPlTD","Active":"HeaderCommunity_Active__aq4sc","Header":"HeaderCommunity_Header__yNaAp"};

/***/ }),

/***/ 355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PlacementTest":"PlacementTest_PlacementTest__5v3ZW","Content":"PlacementTest_Content__BBNM2","Message":"PlacementTest_Message__R2ZG4","Taken":"PlacementTest_Taken__dhrRd","Take":"PlacementTest_Take__900x3"};

/***/ }),

/***/ 6754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__HU9J7","Link":"Projects_Link__EKzHC"};

/***/ }),

/***/ 7333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProjectsCard":"ProjectsCard_ProjectsCard__F_wC1","Content":"ProjectsCard_Content__WVKc1","Title":"ProjectsCard_Title__TeH5k","UserInfo":"ProjectsCard_UserInfo__lDaHg"};

/***/ }),

/***/ 3565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Routes":"Routes_Routes__0N01n"};

/***/ }),

/***/ 6630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RoutesCard":"RoutesCard_RoutesCard__6fZJG","RoutesCardLink":"RoutesCard_RoutesCardLink__mW0FP","RoutesCardButton":"RoutesCard_RoutesCardButton__mWPnt","RoutesCardContent":"RoutesCard_RoutesCardContent__zuRNa","RoutesCardData":"RoutesCard_RoutesCardData__qtzM3","RoutesCardDivisor":"RoutesCard_RoutesCardDivisor__0G_Jv","RoutesCardCourses":"RoutesCard_RoutesCardCourses___XUoo","RoutesCardProfesional":"RoutesCard_RoutesCardProfesional__Ua51a","RoutesCardProgressBar":"RoutesCard_RoutesCardProgressBar__lBXtj","RoutesCardFooter":"RoutesCard_RoutesCardFooter__8233p","RouteCompleted":"RoutesCard_RouteCompleted__MElpP","RouteInProgress":"RoutesCard_RouteInProgress___iARn"};

/***/ }),

/***/ 8171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RoutesHeader":"RoutesHeader_RoutesHeader__3NulF","active":"RoutesHeader_active__7293d"};

/***/ }),

/***/ 432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RoutesSection":"RoutesSection_RoutesSection__hJJwk","RoutesSectionContent":"RoutesSection_RoutesSectionContent__zdxdK","RoutesSectionDescription":"RoutesSection_RoutesSectionDescription__MPwd4","RoutesSectionCards":"RoutesSection_RoutesSectionCards__G_rIw"};

/***/ }),

/***/ 1862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RoutesSimpleSection":"RoutesSimpleSection_RoutesSimpleSection__xHMpi","Grid":"RoutesSimpleSection_Grid__6rqe9"};

/***/ }),

/***/ 9111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__RWZEk","Active":"Tabs_Active__NoLeP"};

/***/ }),

/***/ 8795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TitleSection":"TitleSection_TitleSection__MQxPI"};

/***/ }),

/***/ 3700:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tutorials":"Tutorials_Tutorials__1z6Ol","Link":"Tutorials_Link__9dRZl"};

/***/ }),

/***/ 8015:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TutorialsCard":"TutorialsCard_TutorialsCard__2s4MS","Content":"TutorialsCard_Content__CpJds","Info":"TutorialsCard_Info__71UDF","Footer":"TutorialsCard_Footer__CQSOh"};

/***/ }),

/***/ 5795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PricingTable":"PricingTable_PricingTable__E_j8O","u-wrapper":"PricingTable_u-wrapper___6Hwv"};

/***/ }),

/***/ 5853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Button":"ShareButton_Button__MY_Um"};

/***/ }),

/***/ 7601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Card":"ShareModal_Card__rLkVi","CloseModal":"ShareModal_CloseModal__J_QIj","Input":"ShareModal_Input__RMeqj","whatsapp":"ShareModal_whatsapp__8X5JP","twitter":"ShareModal_twitter__StxBu","telegram":"ShareModal_telegram__Jhw_w","facebook":"ShareModal_facebook__N9jUp","linkedin":"ShareModal_linkedin__3n41N"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,385,934,594,112,885,617,525,774,888,179], function() { return __webpack_exec__(3278); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);